import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[focus]'
})
export class FocusDirective {
constructor(private el: ElementRef, private renderer: Renderer2) {
       
    }

@Input()
  set focus(focus : boolean){
    var t = focus ? 'true' : 'false';
    this.renderer.setAttribute(this.el.nativeElement,'focus',t); 
  }
}

